import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Features } from '../models/features.model';
import { CollectApiServiceBase } from './collect-api-base.service';
import { ProgressIndicatorService } from './progress-indicator.service';

@Injectable({
  providedIn: 'root'
})

 //TEAMS-424: KLW - Created a front end service to handle the features returned from calling the back end
export class FeaturesService extends CollectApiServiceBase<Features> {

    constructor(http: HttpClient, progressIndicatorService: ProgressIndicatorService) {
        super(http, progressIndicatorService, environment.apiUrl, 'Features', Features)
    }

    public getFeatures() {
        var url = `${this.url}/${this.endpoint}`;

        return this.http.get<Features[]>(url)
            .toPromise()
            .then(response => {
                var retVal = response.sort((a, b) => a.name.localeCompare(b.name))

                return (retVal);
            })
            .catch(this.handleError);
    }

}
